import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'signup-modal_open_pdp_main_cta-click';
/**
 * Event fired when user clicks the main sign up cta in the product page
 */
export function trackSignupModalOpenPdpMainCtaClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
